<div
  class="relative flex flex-col flex-1 overflow-y-auto overflow-x-hidden bg-white dark:bg-slate-900"
>
  <main class="grow">
    <div class="px-4 sm:px-6 lg:px-8 py-8 w-full max-w-9xl mx-auto">
      <div class="max-w-2xl m-auto mt-16">
        <div class="text-center px-4">
          <div class="inline-flex mb-8" >
            <img
              class="dark:hidden"
              src="assets/images/not-found.svg"
              width="176"
              height="176"
              alt="404 illustration"
            />
            <img
              class="hidden dark:block"
              src="assets/images/not-found.svg"
              width="176"
              height="176"
              alt="404 illustration dark"
            />
          </div>
          <div>
            <h1 class="ord-h1">404 - Page not found</h1>
            <p class="ord-subtitle-1">
              The page you're looking for doesn't exist or might have been
              removed.
            </p>
            <p class="ord-body-1">
              Please check the URL or go back to the home page:
            </p>
          </div>

          <div class="mt-14">
            <app-button (btnClick)="onBackButtonClicked()">
              <ng-template appButtonText>Back To Home</ng-template>
            </app-button>
          </div>
        </div>
      </div>
    </div>
  </main>
</div>
